import MaterialApi from '@/api/warehouse/material/MaterialApi'
import { setAlertError } from '@/utils/store/alert'

const CERTIFICATE_ERRORS = {
  getReserve: 'Не удалось получить текущие резервы материалов',
  getMaterialsForReserve: 'Не удалось получить список материалов',
  setReserve: 'Не удалось зарезервировать материал'
}

export default {
  /*
  * Получение материалов для резервирования по d_wire и article
  * */
  getMaterialsForReserve: async (data) => {
    try {
      return await MaterialApi.getMaterialsForReserve(data)
    } catch (e) {
      await setAlertError(e, CERTIFICATE_ERRORS.getMaterialsForReserve)
    }
  },

  /*
  * Получение текущих резервов для материала отдельным запросом (сейчас не используется)
  * */
  getReserve: async (id) => {
    try {
      return await MaterialApi.getReserve(id)
    } catch (e) {
      await setAlertError(e, CERTIFICATE_ERRORS.getReserve)
    }
  },

  /*
  * Резервирование материала
  * */
  setReserve: async (id, data) => {
    try {
      return await MaterialApi.setReserve(id, data)
    } catch (e) {
      await setAlertError(e, CERTIFICATE_ERRORS.setReserve)
    }
  }
}
